import { CalculationProcessChainResponse } from 'store/types/assembler'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts'

const COLORS = {
  origin: [
    'hsl(var(--chart-2))',
    'hsl(var(--chart-1))',
    'hsl(var(--chart-3))',
    'hsl(var(--chart-4))',
  ],
  category: [
    'hsl(var(--chart-1))',
    'hsl(var(--chart-3))',
    'hsl(var(--chart-4))',
    'hsl(var(--chart-5))',
  ],
}

type EmissionChartsProps = {
  emissionsByCategory?: CalculationProcessChainResponse['emissionsByCategory']
  emissionOriginComposition?: CalculationProcessChainResponse['emissionOriginComposition']
}

export const EmissionCharts = ({
  emissionsByCategory,
  emissionOriginComposition,
}: EmissionChartsProps) => {
  const originChartData = [
    { name: 'Biogenic', value: emissionOriginComposition?.biogenic ?? 0 },
    { name: 'Fossil', value: emissionOriginComposition?.fossil ?? 0 },
    { name: 'LULUC', value: emissionOriginComposition?.luluc ?? 0 },
    { name: 'Aircraft', value: emissionOriginComposition?.aircraft ?? 0 },
  ].filter((item) => (item.value ?? 0) > 0)

  const categoryChartData = [
    { name: 'Materials', value: emissionsByCategory?.materials ?? 0 },
    { name: 'Production', value: emissionsByCategory?.production ?? 0 },
    { name: 'Logistics', value: emissionsByCategory?.logistics ?? 0 },
    { name: 'Components', value: emissionsByCategory?.components ?? 0 },
  ].filter((item) => (item.value ?? 0) > 0)

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle>Emissions by Category</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={categoryChartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) =>
                  `${name}: ${(percent * 100).toFixed(1)}%`
                }
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {categoryChartData.map((_entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS.category[index % COLORS.category.length]}
                  />
                ))}
              </Pie>
              <Tooltip
                formatter={(value: number) => value.toFixed(5) + ' kg CO₂e'}
              />
            </PieChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Emission Origin Composition</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={originChartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) =>
                  `${name}: ${(percent * 100).toFixed(1)}%`
                }
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {originChartData.map((_entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS.origin[index % COLORS.origin.length]}
                  />
                ))}
              </Pie>
              <Tooltip
                formatter={(value: number) => value.toFixed(5) + ' kg CO₂e'}
              />
            </PieChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  )
}
